module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6e9b5898b906a3e68eadcad1bcdc51d3.gif";